"use client";

import { c as _c } from "react/compiler-runtime";
import { IoIosGitCompare } from "react-icons/io";
import { FiChevronDown } from "react-icons/fi";
const CompetitorComparison = t0 => {
  const $ = _c(49);
  const {
    competitorComparison,
    setCompetitorComparison,
    showCompetitorInput,
    setShowCompetitorInput,
    selectedCompetitor,
    setSelectedCompetitor,
    selectedIndication,
    productName,
    onBack,
    onNext
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-2 sm:gap-3 mb-2"><div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-primary-primaryBlue/10 flex items-center justify-center flex-shrink-0"><IoIosGitCompare className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-primary-primaryBlue" /></div><h2 className="text-base sm:text-xl font-bold text-gray-900 font-poppins">Competitor Comparison</h2></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = selectedIndication || "No indication";
  let t3;
  if ($[1] !== t2) {
    t3 = <span className="font-semibold">{t2}</span>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = productName || "this product";
  let t5;
  if ($[3] !== t4) {
    t5 = <span className="font-semibold">{t4}</span>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t3 || $[6] !== t5) {
    t6 = <p className="text-xs sm:text-sm text-gray-600 font-poppins mb-4 sm:mb-6">Compared to your usual alternative for {t3}, {t5} is...</p>;
    $[5] = t3;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = selectedIndication || "No indication";
  let t8;
  if ($[8] !== t7) {
    t8 = <p className="text-[10px] sm:text-xs text-gray-500 font-poppins mb-3 sm:mb-4">Auto-selected: Same indication ({t7})</p>;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = ["Much Worse", "Worse", "Same", "Better", "Much Better"];
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== competitorComparison || $[12] !== setCompetitorComparison) {
    t10 = <div className="mb-3 sm:mb-4"><div className="grid grid-cols-2 sm:grid-cols-3 md:flex gap-2">{t9.map(option => <button key={option} onClick={() => setCompetitorComparison(option)} className={`flex-1 px-2 sm:px-3 py-2 sm:py-2.5 rounded-lg border-2 text-xs sm:text-sm font-semibold font-poppins transition-all ${competitorComparison === option ? "bg-primary-primaryBlue text-white border-primary-primaryBlue" : "bg-white text-gray-700 border-gray-200 hover:border-primary-primaryBlue/50"}`}>{option}</button>)}</div></div>;
    $[11] = competitorComparison;
    $[12] = setCompetitorComparison;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== setShowCompetitorInput || $[15] !== showCompetitorInput) {
    t11 = () => setShowCompetitorInput(!showCompetitorInput);
    $[14] = setShowCompetitorInput;
    $[15] = showCompetitorInput;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span>Optional: Which alternative(s) are you comparing to?</span>;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  const t13 = `w-3.5 h-3.5 sm:w-4 sm:h-4 transition-transform flex-shrink-0 ml-2 ${showCompetitorInput ? "rotate-180" : ""}`;
  let t14;
  if ($[18] !== t13) {
    t14 = <FiChevronDown className={t13} />;
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t11 || $[21] !== t14) {
    t15 = <button type="button" onClick={t11} className="w-full flex items-center justify-between text-xs sm:text-sm font-medium text-gray-700 font-poppins hover:text-primary-primaryBlue transition-colors">{t12}{t14}</button>;
    $[20] = t11;
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== selectedCompetitor || $[24] !== setSelectedCompetitor || $[25] !== showCompetitorInput) {
    t16 = showCompetitorInput && <div className="mt-2 sm:mt-3"><input type="text" value={selectedCompetitor} onChange={e => setSelectedCompetitor(e.target.value)} placeholder="e.g., Saxenda, Zepbound, older GLP-1s" className="w-full rounded-lg border-2 border-gray-200 focus:border-primary-primaryBlue focus:outline-none transition-colors px-3 sm:px-4 py-2 sm:py-2.5 text-xs sm:text-sm font-poppins" /></div>;
    $[23] = selectedCompetitor;
    $[24] = setSelectedCompetitor;
    $[25] = showCompetitorInput;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t15 || $[28] !== t16) {
    t17 = <div className="border-t border-gray-200 pt-3 sm:pt-4">{t15}{t16}</div>;
    $[27] = t15;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t10 || $[31] !== t17 || $[32] !== t8) {
    t18 = <div className="bg-white rounded-lg border border-gray-200 p-3 sm:p-5">{t8}{t10}{t17}</div>;
    $[30] = t10;
    $[31] = t17;
    $[32] = t8;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== t18 || $[35] !== t6) {
    t19 = <div className="flex-1 overflow-y-auto hide-scrollbar px-4 sm:px-6 py-3 sm:py-4"><div className="mb-4 sm:mb-6">{t1}{t6}{t18}</div></div>;
    $[34] = t18;
    $[35] = t6;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== onBack) {
    t20 = <button onClick={onBack} className="flex-1 border-2 border-gray-300 text-gray-700 text-sm sm:text-base font-semibold font-poppins rounded-lg py-2.5 sm:py-3 hover:bg-gray-50 transition-colors">Back</button>;
    $[37] = onBack;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  const t21 = !competitorComparison;
  const t22 = `flex-1 text-white rounded-lg text-sm sm:text-base font-semibold font-poppins py-2.5 sm:py-3 transition-all ${competitorComparison ? "bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 shadow-md hover:shadow-lg transform hover:scale-[1.02]" : "bg-gray-300 cursor-not-allowed"}`;
  let t23;
  if ($[39] !== onNext || $[40] !== t21 || $[41] !== t22) {
    t23 = <button onClick={onNext} disabled={t21} className={t22}>Next</button>;
    $[39] = onNext;
    $[40] = t21;
    $[41] = t22;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] !== t20 || $[44] !== t23) {
    t24 = <div className="px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-200 bg-white flex gap-2 sm:gap-3 flex-shrink-0">{t20}{t23}</div>;
    $[43] = t20;
    $[44] = t23;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== t19 || $[47] !== t24) {
    t25 = <>{t19}{t24}</>;
    $[46] = t19;
    $[47] = t24;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  return t25;
};
export default CompetitorComparison;